import toast from "react-hot-toast";
import { convertDate } from "../../utils/utils";

const { clientAPI } = require("../client");
export const employeeCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/employee", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/employee/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  // Tra dữ liệu hệ thống đang có để HCNS đối chiếu nguồn giới thiệu khi duyệt hồ sơ
  checkReferralSource: async (id) => {
    try {
      const response = await clientAPI(
        "get",
        `/employee/referralSource/check/${id}`,
      );
      return response;
    } catch (error) {
      console.error("CheckReferralSource error:", error);
      throw error;
    }
  },
  updateStatusIsProfileCompleted: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/employee/updateStatusProfile/${id}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("UpdateStatusProfile error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateHiddenStatus: async (id) => {
    try {
      const response = await clientAPI(
        "put",
        `/employee/updateHiddenStatus/${id}`,
      );
      return response;
    } catch (error) {
      console.error("UpdateHiddenStatus error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateStatus: async (data) => {
    try {
      const response = await clientAPI("post", "/employee/adminUpdateStatus", {
        _id: data.id,
        status: data.status,
        ...(data.startTime ? { startTime: data.startTime } : {}),
      });
      return response;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updatePassword: async (data) => {
    console.log({ data });
    try {
      const response = await clientAPI(
        "post",
        "/employee/adminUpdatePassword",
        {
          _id: data.id,
          password: data.password,
        },
      );
      return response;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  checkCodeUnique: async (code) => {
    try {
      const response = await clientAPI("get", `/employee/code/${code}`);
      if (!response) {
        return true;
      }
      return false;
    } catch (error) {
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  roleUser: async (id) => {
    try {
      const response = await clientAPI("get", `/employee/roleUser/${id}`);
      return response;
    } catch (error) {
      console.error("roleUser error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  get: async (id) => {
    try {
      const response = await clientAPI("get", `/employee/${id}`);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getEmployeeDetailKPI: async (param) => {
    try {
      const options = {};
      if (param?.code) options.code = param.code;
      if (param?.month) options.month = param.month;
      if (param?.year) options.year = param.year;

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI(
        "get",
        `/document/api/v2/msh/evaluations/sale-kpis/monthly/detail?${queryParams}`,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getRelativeById: async (id) => {
    try {
      const response = await clientAPI(
        "get",
        `/relativeRegisterForm/app/myRelative?employeeId=${id}&page=1&limit=9999`,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  disbursement: async (id) => {
    try {
      const response = await clientAPI("put", `/employee/disbursement/${id}`);
      return response;
    } catch (error) {
      console.error("disbursement error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updatePasswordCurrent: async (data) => {
    try {
      const response = await clientAPI(
        "put",
        "/employee/updatePasswordWeb",
        data,
      );
      return response;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  logout: async (data) => {
    try {
      const response = await clientAPI("post", "/employee/logout", data);
      return response;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  sendOtp: async (data) => {
    try {
      const response = await clientAPI("post", `/employee/app/sendOtp/`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  verifyOtp: async (data) => {
    try {
      const response = await clientAPI(
        "post",
        `/employee/app/verifyOtp/`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  resetPassword: async (data, accessToken) => {
    try {
      const response = await clientAPI(
        "post",
        `/employee/app/resetPassword/`,
        data,
        accessToken,
      );
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  createRelative: async (data) => {
    try {
      const response = await clientAPI("post", "/employee/createRelative", data);
      return response;
    } catch (error) {
      console.error("CreateRelative error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  bulkAdd: async (data, department) => {
    const dataFilter = data.map((item, index) => {
      return {
        code: item?.code || "",
        fullName: item?.fullName || "",
        gender:
          item?.gender !== "" &&
          item?.gender !== undefined &&
          item?.gender !== null
            ? item?.gender
            : "",
        dateOfBirth: item?.dateOfBirth ? convertDate(item?.dateOfBirth) : "",
        identificationNumber: item?.identificationNumber
          ? item?.identificationNumber.toString()
          : "",
        phone: item?.phone ? item?.phone.toString() : "",
        email: item?.email || "",
        permanentAddress: item?.permanentAddress || "",
        currentAddress: item?.currentAddress || "",
        startTime: item?.startTime ? convertDate(item?.startTime) : "",
        bankAccount: item?.bankAccount ? item?.bankAccount.toString() : "",
        referralCodeId: item?.referralCodeId || "",
        saleBlockCode: item?.saleBlockCode || "",
        saleBlockName: item?.saleBlockName || "",
        saleAreaCode: item?.saleAreaCode || "",
        saleAreaName: item?.saleAreaName || "",
        depositDate: item?.depositDate ? convertDate(item?.depositDate) : "",
        department: item?.department || 0,
      };
    });

    const filteredData = dataFilter.map((obj) =>
      Object.fromEntries(
        Object.entries(obj).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null,
        ),
      ),
    );
    console.log(filteredData);
    try {
      const response = await clientAPI("post", "/employee/bulk/", filteredData);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  downLoadContract: async (id) => {
    try {
      const response = await clientAPI(
        "get",
        `/employee/downloadContract/${id}`,
      );
      return response;
    } catch (error) {
      console.error("downLoadContract error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },

  bulkMany: async (input, name) => {
    try {
      const data = {
        input,
        name,
      };
      const response = await clientAPI("post", "/employee/bulkMany/", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  importLeaveBalance: async (input, name) => {
    try {
      const data = {
        input,
        name,
      };
      const response = await clientAPI(
        "post",
        "/employee/importLeaveBalance/",
        data,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
